// @flow
import auth0 from 'auth0-js'

export class Metadata {

  webAuth: auth0
  management: auth0.Management

  constructor() {

    // --- Web Auth Config ---
    this.webAuth = new auth0.WebAuth({
      clientID: 'RcMXnSsex9tpwtiXsRXz3DCIWviuM9K0',
      domain: 'login.optionsedu.com',
      redirectUri: String(process.env.REACT_APP_ROOT),
      audience: 'https://optionsedu.auth0.com/api/v2/',
      scope: 'create:current_user_metadata update:current_user_metadata',
      responseType: 'token id_token'
    })
  }

  checkManagementToken = (): Promise<string> => {

    return new Promise((resolve, reject) => {

      // check if new token is needed
      if (!this.isTokenValid()) {

        // get new token
        this.webAuth.checkSession({}, (err: Object, res: Object) => {

          // reject errors
          if (err) return reject(err.description)

          // save access token
          localStorage.setItem('web_expires', JSON.stringify(86400000 + new Date().getTime()))
          localStorage.setItem('web_id', res.idToken)
          return resolve(res.idToken)
        })

      } else return resolve(String(localStorage.getItem('web_id')))
    })
  }

  isTokenValid = (): boolean => {

    const expiresAt: number = Number(JSON.parse(window.localStorage.getItem('web_expires'))) || 0
    return new Date().getTime() < expiresAt
  }

  getUser = (): Promise<Object> => {

    return new Promise((resolve, reject) => {

      // check for valid token
      this.checkManagementToken()
        .then((accessToken: string) => {

          // set management
          const management = new auth0.Management({
            domain: 'optionsedu.auth0.com',
            token: accessToken
          })

          // get user
          const uid: string = String(localStorage.getItem('user_uid'))
          management.getUser(uid, (err: Object, user: Object) => {

            // :::: LOG GET USER ::::
            if (err) console.error('GET USER ERROR:', err)
            else console.log('GET USER SUCCESS:', user)

            // reject errors or resolve user
            if (err) return reject(err)
            return resolve(user)
          })
        })
        .catch(reject)
    })
  }

  updateUserMetadata = (metadata: Object) => {

    // check for valid token
    this.checkManagementToken()
      .then((accessToken: string) => {

        // set management
        const management = new auth0.Management({
          domain: 'optionsedu.auth0.com',
          token: accessToken
        })

        // update metadata
        const uid: string = String(localStorage.getItem('user_uid'))
        management.patchUserMetadata(uid, metadata, (err: Object, user: Object) => {

          // :::: LOG UPDATE ::::
          if (err) console.error('UPDATE USER METADATA ERROR:', err)
          else console.log('UPDATE USER METADATA SUCCESS:', user)

          // log errors or user
          if (err) return console.error('user update error', err)
        })
      })
      .catch(console.error)
  }

  resetUserPassword = ({ email }: Object): Promise<string> => {
    
    return new Promise((resolve, reject) => {

      this.webAuth.changePassword({
        connection: "OptionsEDU-DB",
        email: email
      }, (err: Object) => {

        if (err) return reject('Unable to reset password, please try again later.')
        else return resolve(`Password reset instructions sent to ${email}.`)
      })
    })
  }

  // on log out
  logout = () => {

    // log out AuthLock & return to login
    this.webAuth.logout({
      returnTo: String(process.env.REACT_APP_ROOT)
    })
  }
}


// WEBPACK FOOTER //
// ./src/services/metadata/index.js